import {
	ReactElement,
	useEffect,
	useState
} from "react";
import { Spinner } from "../Spinner/Spinner";
import styles from "./BusyIndicator.module.less";
import { setTrackingId } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";

export const BusyIndicator = (): ReactElement => {
	const [showScreenReaderAnnouncement, setShowScreenReaderAnnouncement] = useState<boolean>(false);

	useEffect(
		(): void => {
			// Delay mounting the message until after the initial render
			// to ensure screen readers announce it reliably
			setTimeout(
				(): void => {
					setShowScreenReaderAnnouncement(true);
				},
				1
			);
		},
		[]
	);

	return (
		<div
			{...setTrackingId("busy-indicator")}
			className={styles.root}
			role="status"
		>
			<Spinner />
			{showScreenReaderAnnouncement && (
				<span className={styles.textHelper}>{localize("_Loading")}</span>
			)}
		</div>
	);
};
BusyIndicator.displayName = "BusyIndicator";
